<template>
    <section id="wizard-edit-content" class="step-content-slot">
        <div class="wizard-component container">
            <Heading
                title="Your Campaign"
                description="Tags are for campaign search visibility"
            />
            <div class="wizard-content mt-4" v-if="cardData">
                <div class="row">
                    <div class="col-md-8 col-12">
                        <div class="row">
                            <div class="col-md-5 col-12">
                                <div id="left-side" class="left-side">
                                    <div class="product-img">
                                        <Thumbnail
                                            id="card-img"
                                            size = "original" 
                                            :data="cardData" 
                                            class-name="w-100 img-fluid"
                                            alt="" />
                                    </div>
                                    <div v-if="cardData.backers" class="prod-backers float-md-none float-left">
                                        <span class="lab c10 my-2 d-block">backers</span>
                                        <p id="backers-count" class="h4b c7 mb-0">{{cardData.backers}}</p>
                                    </div>
                                    <div class="product-info mt-2 d-flex align-items-center">
                                        <div class="info-img float-left mr-3">
                                            <a 
                                                id="kick-url"
                                                :href="cardData.project_url"
                                                target="_blank"
                                                @click='fireKsLinkEvent'
                                                v-b-tooltip.hover
                                                title="Opens in a new window."
                                            >
                                                <Indiegogo v-if="cardData.platform === 'indiegogo'" />
                                                <Kickstarter v-else />
                                            </a>
                                        </div>
                                        <div class="product-passing d-flex flex-column">
                                            <div class="product-status">
                                                <p class="lab mr-3 mb-0 text-capitalize" id="card-state" :class="cardData.state">
                                                    {{cardData.state}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-7 col-12">
                                <div class="right-side">
                                    <div class="product-bio mt-md-0 mt-5">
                                        <div class="product-title position-relative">
                                            <p id="card-title" class="c6 p3b">{{cardData.title}}</p>
                                        </div>
                                        <div class="product-desc position-relative">
                                            <p id="card-desc" class="c3 p2n">{{cardData.description}}</p>
                                        </div>
                                    </div>
                                    <div class="product-about mt-5 mb-3">
                                        <p class="c9 lab d-block mb-2">Category</p>
                                        <p id="card-category" class="p3n c3">{{cardData.category}}</p>
                                    </div>
                                    <div :class="{'err-tags-place': tagsErrorText.length}" class="add-tags-place">
                                        <span class="c9 lab d-block mb-2">Tags</span>
                                        <md-chips
                                            md-placeholder="Add Tag..."
                                            :md-limit="5"use
                                            :md-format="tagsValidation"
                                            v-model="tags">
                                        </md-chips>
                                        <p class="tag-err-state" v-if="tagsErrorText">{{tagsErrorText}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import { getDataByDocId, updateData } from '../../firebaseCRUD';
    import { Kickstarter, Indiegogo } from '../Icons'
    import Heading from "../Theme/Heading";
    import Thumbnail from '../Theme/Thumbnail'
    import {DEFAULT_CAMPAIGN_COLLECTION} from "../../firebase";

    export default {
        name: "EditCampaign",
        components: {
            Kickstarter,
            Indiegogo,
            Heading,
            Thumbnail
        },
        props: {
            cardData: Object
        },

        data() {
            return {
                authUserUid: this.$store.state.user.uid,
                titleReadonly: true,
                descReadonly: true,
                tags: [],
                tagsErrorText: ''
                
            }
        },
        watch: {
            'cardData': 'initData'
            // '$route.query.id': 'getCardDataFromFirebase'
        },
        mounted () {
            // this.getCardDataFromFirebase()

            if(this.cardData){
                this.initData(this.cardData);
            }

            this.$emit('disableNext', false);

            this.$emit('setChildEvent', {
                next: this.updateCardDataFromFirebase
            });
        },
        methods: {
            tagsValidation(value) {
                if(value.length > 16) {
                    this.tagsErrorText = "You've reached the character limit per tag"
                    return 
                }
                this.tagsErrorText = ""
                return value
            },
            fireKsLinkEvent(){
                this.$sendMixpanelEvent('KS Icon Clicked', {
                    'KS Icon Location': 'Add Wizard',
                    'Viewed Campaign': this.cardData.title
                })
                this.$ga.event('Campaign', 'KS Icon Click', `
                    Location: Add Wizard,
                    Campaign: ${this.cardData.title}
                `)
            },
            initData(data){
                if(data && data.tags){
                    this.tags = [...data.tags];
                }
            },
            updateCardDataFromFirebase: async function() {
                if(!this.cardData) return
                if(JSON.stringify(this.cardData.tags) === JSON.stringify(this.tags)){
                    return
                }
                try {
                    const data = {
                        tags: this.tags || [],
                    }
                    await updateData({
                        id: this.cardData.docId,
                        collection: DEFAULT_CAMPAIGN_COLLECTION,
                        data
                    });
                    this.$emit('setData', {
                        ...this.cardData,
                        tags: this.tags
                    })
                    this.$sendMixpanelEvent('Add Wizard', {
                        'Step Number': 2,
                        'Action': 'Tags Added'
                    })

                    this.$ga.event('Add Wizard', 'Add Tags', 'Step', 2)
                    
                } catch (e) {
                    this.$store.dispatch('handleErrors', e)
                }
            },
            disableTitleEditing: function () {
                this.titleReadonly = true;
            },
            disableDescEditing: function () {
                this.descReadonly = true;
            },
            titleEnable: function () {
                this.titleReadonly = false;
            },
            descEnable: function () {
                this.descReadonly = false;
            },
        }
    }
</script>

<style lang="scss">
div.right-side {
    div.add-tags-place.err-tags-place {
        p.tag-err-state {
            color: #FA5C7C;
            font-size: 11px;
        }
        div.md-field {
            border-bottom: 2px solid #FA5C7C;
            margin-bottom: 0 !important;
            &::before, &::after {
                background-color: #FA5C7C;
            }
        }
    }
}
    div.product-about {
        button {
            width: 200px !important;
            height: 30px;
            background: #ffffff;
            color: #333333;
            border: 1px solid #00000026 !important;
            border-radius: 5px;
            text-align: left;
            padding: 0;
            padding-left: 5px;

            &::after {
                content: "";
                border-top: 0.3em solid #00000026;
                border-right: 0.3em solid transparent;
                border-bottom: 0;
                border-left: 0.3em solid transparent;
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translate(-20px, -50%);

            }

            &.dropdown-toggle {
                background: #ffffff !important;
                color: #333333 !important;
                box-shadow: none !important;
                border: 1px solid #00000026 !important;
            }

            &:focus {
                background: #ffffff !important;
                color: #333333 !important;
                box-shadow: none !important;
                border: 1px solid #00000026 !important;
            }

            &:hover {
                background: #ffffff;
                box-shadow: none !important;
                color: #333333;
                border: 1px solid #00000026 !important;
            }
        }

        ul.dropdown-menu {
            width: 100%;

            li {
                &:focus {
                    outline: none;
                }

                a {
                    color: #333333 !important;
                    padding-left: 10px;

                    &:active {
                        background: transparent;
                    }
                }
            }
        }
    }
    div.add-tags-place {
        button.md-clear {
            i {
                svg {
                    &:hover {
                        path {
                            fill: none;
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped lang="scss">
    p:focus,
    span:focus {
        border: 0;
        outline: 0;
    }

    .product-title {
        textarea {
            height: 45px;
        }
    }

    .product-desc {
        textarea {
            height: 85px;
        }
    }

    .product-title,
    .product-desc,
    .product-about {
        width: 265px;

        textarea {
            width: 100%;
            resize: none;
            border: 1px solid transparent;
            overflow: hidden;

            &.enabledTextarea {
                border: 1px solid #00000026;
            }
        }

        img {
            left: 100%;
            top: 100%;
            transform: translate(0, -100%);
        }

    }
    .add-tags-place {
        min-width: 475px;
    }


</style>